export default "__VITE_ASSET__BWx2DqDQ__"